// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart[data-v-2933ba85]{display:flex;flex-direction:column;justify-content:center;align-items:center}.chart[data-v-2933ba85],.myChart[data-v-2933ba85]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
